import {WidgetDefinition, WidgetTextStyle} from "./common";
import WidgetType from "../enum/WidgetType";
import Font from '../enum/Font';
import TextAlignment from "../enum/TextAlignment";
import WidgetSettingsPromotionMode from '../enum/WidgetSettingsPromotionMode';
import PriceMode from '../enum/PriceMode';
import AssetContentMode from "../enum/AssetContentMode";

const Promotion: WidgetDefinition = {

    type: WidgetType.PROMOTION,
    className: "widget-promotion",
    contentComponent: "dmb-widget-content-promotion",

    settingsSectionComponents: [
        "dmb-section-widget-settings-promotion",
        "dmb-section-widget-style",
        'dmb-section-widget-animation'
    ],

    defaultSize: {
        width: 0.65,
        height: 0.4
    },

    minSize: {
        width: 0.2,
        height: 0.2
    },

    defaultStyle: {
        opacity: 100,
        padding: 10,
        contentMode: AssetContentMode.COVER
    },

    defaultSettings: (options) => ({
        mode: WidgetSettingsPromotionMode.SPECIFIC,
        showTitle: true,
        showSubtitle: true,
        showPriceRegular: true,
        showPricePromo: true,
        showCurrency: true,
        priceMode: PriceMode.DECIMAL_COMMA,
        showImage: true,
        promotionId: options.isTemplate ? '0' : null,
        titleTextStyle: {
            size: 30,
            font: Font.PRIMARY,
            bold: true,
            color: 'FFFFFF',
            alignment: null,
            borderColor: null,
            borderSize: null,
            characterSpacing: null,
            customFont: null,
            italic: null,
            lineSpacing: null,
            shadowBlur: null,
            shadowColor: null,
            shadowOffsetX: null,
            shadowOffsetY: null,
            transform: null,
            underlined: null
        } as WidgetTextStyle,
        subtitleTextStyle: {
            size: 25,
            font: Font.PRIMARY,
            italic: true,
            color: 'FFFFFF',
            alignment: null,
            bold: null,
            borderColor: null,
            borderSize: null,
            characterSpacing: null,
            customFont: null,
            lineSpacing: null,
            shadowBlur: null,
            shadowColor: null,
            shadowOffsetX: null,
            shadowOffsetY: null,
            transform: null,
            underlined: null
        } as WidgetTextStyle,
        priceTextStyle: {
            size: 20,
            font: Font.PRIMARY,
            color: 'FFFFFF',
            alignment: TextAlignment.RIGHT,
            bold: null,
            borderColor: null,
            borderSize: null,
            characterSpacing: null,
            customFont: null,
            italic: null,
            lineSpacing: null,
            shadowBlur: null,
            shadowColor: null,
            shadowOffsetX: null,
            shadowOffsetY: null,
            transform: null,
            underlined: null
        } as WidgetTextStyle,
        pricePromoTextStyle: {
            size: 40,
            bold: true,
            font: Font.PRIMARY,
            color: 'FFFFFF',
            alignment: null,
            borderColor: null,
            borderSize: null,
            characterSpacing: null,
            customFont: null,
            italic: null,
            lineSpacing: null,
            shadowBlur: null,
            shadowColor: null,
            shadowOffsetX: null,
            shadowOffsetY: null,
            transform: null,
            underlined: null
        } as WidgetTextStyle
    })
};

export default Promotion;